<button
  mat-button
  [matMenuTriggerFor]="languageMenu"
  [class.min-w-45]="!compact"
  [class.min-w-0]="compact"
  class="justify-between">
  <div class="flex items-center gap-3">
    <img
      [src]="currentLanguage.flag"
      [alt]="selectedLang"
      class="h-5 w-7 object-cover rounded-sm shrink-0" />

    @if (compact) {
      <span class="font-medium uppercase">
        {{ selectedLang }}
      </span>
    } @else {
      <span class="truncate">
        {{ 'common.languages.' + selectedLang | translate }}
      </span>
    }
  </div>
</button>

<mat-menu #languageMenu="matMenu">
  @for (lang of languages; track lang.code) {
    <button mat-menu-item (click)="changeLang(lang.code)" class="min-w-60">
      <div class="flex items-center gap-3">
        <img [src]="lang.flag" [alt]="lang.code" class="h-5 w-7 object-cover rounded-sm" />

        <span>
          {{ 'common.languages.' + lang.code | translate }}
        </span>
      </div>
    </button>
  }
</mat-menu>
